/* Theme B, 3 Nov 2026: real delivery price and total in the cart drawer and cart page.
   GA4 2 Nov: 97 shoppers entered shipping info, 14 reached payment. The delivery price was a surprise at checkout.
   When the postcode box answers (bms-cro.js fires 'bms:estimate'), this asks Shopify for the SAME rates checkout
   will charge for this exact cart (/cart/shipping_rates.json, which runs the delivery profiles and the Vayu
   postcode rules), then shows "Delivery $X" and "Total $Y" in the order summary.
   If Shopify does not answer, the bms-cro.js wording stays as it was. Never states a delivery date. */
(function () {
  'use strict';
  if (window.__bmsCartRates) return;
  window.__bmsCartRates = true;

  var SUPPORT = 'support@brisbanemarqueesales.com.au';
  var cache = {};

  /* Australia Post postcode ranges to state. Shopify zones are by state, so the state must be right. */
  function state(n) {
    if (n >= 800 && n <= 999) return 'NT';
    if ((n >= 200 && n <= 299) || (n >= 2600 && n <= 2618) || (n >= 2900 && n <= 2920)) return 'ACT';
    if ((n >= 1000 && n <= 2599) || (n >= 2619 && n <= 2899) || (n >= 2921 && n <= 2999)) return 'NSW';
    if ((n >= 3000 && n <= 3999) || (n >= 8000 && n <= 8999)) return 'VIC';
    if ((n >= 4000 && n <= 4999) || (n >= 9000 && n <= 9999)) return 'QLD';
    if (n >= 5000 && n <= 5999) return 'SA';
    if (n >= 6000 && n <= 6999) return 'WA';
    if (n >= 7000 && n <= 7999) return 'TAS';
    return '';
  }

  function money(cents) {
    var d = cents / 100;
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: d % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }

  function rootOf(box) {
    return box.closest('cart-drawer') || box.closest('#main-cart-footer') || box.closest('.cart__footer') || null;
  }

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function getRates(pc, prov, key) {
    if (cache[key]) return Promise.resolve(cache[key]);
    var q = 'shipping_address%5Bzip%5D=' + pc + '&shipping_address%5Bcountry%5D=Australia&shipping_address%5Bprovince%5D=' + prov;
    return fetch('/cart/shipping_rates.json?' + q, { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('rates ' + r.status);
      return r.json();
    }).then(function (j) { cache[key] = j; return j; });
  }

  function paint(root, fee, total) {
    var doc = root || document;
    doc.querySelectorAll('[data-bms-deliv-val]').forEach(function (el) { el.textContent = fee === 0 ? 'Free' : money(fee); });
    doc.querySelectorAll('[data-bms-deliv-hint]').forEach(function (el) { el.hidden = true; });
    doc.querySelectorAll('[data-bms-total-row]').forEach(function (row) {
      var v = row.querySelector('[data-bms-total-val]');
      if (v) v.textContent = money(total);
      row.hidden = false;
    });
  }

  function check(box, state0) {
    var root = rootOf(box);
    if (!root) return;
    var input = box.querySelector('[data-bms-est-input]');
    var out = box.querySelector('[data-bms-est-out]');
    var pc = ((input && input.value) || '').replace(/\D/g, '');
    if (pc.length !== 4 || !out) return;
    var prov = state(parseInt(pc, 10));
    if (!prov) return;
    getCart().then(function (cart) {
      if (!cart.item_count) return;
      var key = pc + '|' + cart.token + '|' + cart.total_price + '|' + cart.item_count;
      return getRates(pc, prov, key).then(function (j) {
        var rates = (j && j.shipping_rates) || [];
        if (!rates.length) {
          out.className = 'bms-est__out bms-est__out--warn';
          out.innerHTML = 'Checkout has no delivery option for ' + pc + ' with this cart. Please email <a href="mailto:' + SUPPORT + '">' + SUPPORT.replace('@', '@<wbr>') + '</a> and we will sort out the freight for you.';
          return;
        }
        var best = rates.reduce(function (a, b) { return parseFloat(b.price) < parseFloat(a.price) ? b : a; });
        var fee = Math.round(parseFloat(best.price) * 100);
        var total = cart.total_price + fee;
        var html = fee === 0
          ? '<strong>Free delivery</strong> to ' + pc + '. Nothing is added at checkout.'
          : 'Delivery to ' + pc + ' is <strong>' + money(fee) + '</strong> (' + best.name + '). That is the price checkout will show.';
        if (fee > 0 && state0 === 'warn') {
          html += ' Remote or NT address? Please <a href="mailto:' + SUPPORT + '?subject=Delivery%20check%20' + pc + '">email us</a> before you order so we can confirm the freight can reach you.';
        }
        out.className = 'bms-est__out bms-est__out--' + (fee === 0 ? 'yes' : state0 === 'warn' ? 'warn' : 'fee');
        out.innerHTML = html;
        out.hidden = false;
        paint(root, fee, total);
      });
    }).catch(function () { /* keep the bms-cro.js answer */ });
  }

  document.addEventListener('bms:estimate', function (e) {
    var d = e.detail || {};
    if (d.box) check(d.box, d.state);
  });

  /* Quantity change or remove on the cart page: the postcode box is outside the re-rendered part, so re-check. */
  function recheckAll() {
    document.querySelectorAll('[data-bms-est]').forEach(function (box) {
      var s = box.getAttribute('data-state') || '';
      check(box, s);
    });
  }
  /* pubsub.js and constants.js load after this file (deferred, later in the page), so subscribe once they exist. */
  function hook() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(recheckAll, 400); setTimeout(recheckAll, 1500); });
      }
    } catch (err) {}
    /* bms-cro.js may have answered a saved postcode before this file was listening: check those boxes now. */
    setTimeout(recheckAll, 300);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', hook); } else { hook(); }
})();
